import script from "./VoucherCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherCard.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherCard.vue?vue&type=style&index=0&id=451bfcf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451bfcf8"]])

export default __exports__